import React, { useEffect } from 'react';
import useSWR from 'swr';
import Input from 'components/Input';
import { deepFilterValues, filterValues } from 'Helper';
import { Box, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker, LocalizationProvider } from '@mui/lab';
import StartSwitch from 'components/Switch';
import MultipleSelectPlaceholder from 'components/MultiSelectv3';
import { toast } from 'react-toastify';
import FileUpload from 'components/FileUpload';
import { apiRequest } from 'store/Misc/apiRequest';
// import { getImpressions } from '../getImpression';
import { useDispatch } from 'react-redux';
import { setImpressions } from 'store/slices/miscSlice';

export default function FormThree() {
  const { setValue, control, watch } = useFormContext()
  const { data: frequencies } = useSWR('promos/frequencies')
  const [date, setDate] = React.useState('');
  const [budgetError, setBudgetError] = React.useState(false);
  const [now, setNow] = React.useState(false);
  const { data: schedules } = useSWR('promos/schedules')
  const dispatch = useDispatch()

  useEffect(() => {
    if (schedules) {
      if (schedules.data.length === 0) {
        toast.warning('You have to create a schedule')
      }
    }
  }, [schedules])

  useEffect(() => {
    const run = () => {
      let thisMoment = new Date().toLocaleString()
      setValue('start', thisMoment)
    }
    run()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [now])

  const checkSufficientBalance = async () => {
    if (watch('budget')) {
      await apiRequest({
        method: 'post',
        url: 'promos/campaigns/check/available-credit',
        payload: { budget: watch('budget'), type: 'credit' }
      }).then(res => setBudgetError(false))
        .catch(err => setBudgetError(true))
    }
  }

  useEffect(() => {
    if (date.start > date.end) {
      toast.error('Start date can not be after the ')
    }
    setValue('start', date.start)
    setValue('end', date.end)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date])

  const PickDate = ({ name, label, sx, style, required, display }) => {
    const handleChange = (newValue) => {
      setDate({ ...date, [name]: newValue })
    }
    return (
      <>
        <Controller
          control={control}
          name={name}
          rules={{ required: required }}
          render={({ field: { onChange, onBlur, value }, fieldState: { error } }) => (
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <label></label>
              <DateTimePicker
                label={label} key={name}
                value={date ? date[name] : ''} style={{ border: 'none !important', display: display }}
                onChange={handleChange}
                renderInput={(params) => <TextField required={false} placeholder='name' value={date[name]} name={name} {...params} sx={sx} style={style} />}
              />
            </LocalizationProvider>
          )} />
      </>
    );
  };

  const fields = [
    {
      name: 'budget',
      label: 'Campaign Budget',
      type: 'number',
      placeholder: 'eg. NGN 2000',
      required: true,
      id: 'budgetId',
      blur: () => { checkSufficientBalance(); dispatch(setImpressions(watch('budget'))) }
    },
    [
      {
        name: 'start',
        label: 'Start date',
        display: now ? 'none' : 'block',
        required: true
      },
      {
        name: 'end',
        label: 'End Date',
        display: 'block',
        required: true
      },
      {
        name: 'start',
        label: '',
        labelwithin: '',
        type: 'checkbox',
        display: 'block',
        required: true
      }
    ],
    [
      {
        name: 'promo_frequency_id',
        label: 'Frequency of campaign',
        type: 'select', placeholder: 'Select hours to repeat campaign',
        options: frequencies?.data ? filterValues({ options: frequencies?.data, param: { label: 'name', value: 'id' } }) : [],
        required: true

      },
      {
        name: 'schedules',
        label: 'Select schedules', type: 'selectWithBtn', idKey: 'id', valueKey: 'from.name_12,to.name_12', placeholder: 'Select hours to repeat campaign',
        options: schedules?.data ? deepFilterValues({ options: schedules?.data, param: { label: 'day', value: 'id', optional: 'from.name_12,to.name_12' } }) : [],
        required: true
      },
      {
        name: 'media',
        label: 'Upload video or photo',
        type: 'file',
        required: true
        // options: schedules?.data ? deepFilterValues({ options: schedules?.data, param: { label: 'day', value: 'id', optional: 'from.name_12,to.name_12' } }) : []
      }
    ]
  ]

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', width: '100%', gap: '24px' }}>
      <Input
        name={fields[0].name}
        label={fields[0].label}
        type={fields[0].type}
        options={fields[0]?.options}
        placeholder={fields[0].placeholder}
        variant="filled"
        required={fields[0].required}
        onblur={fields[0].blur}
        id={fields[0].id}
      />
      <p className='text-danger' style={{ display: budgetError ? 'block' : 'none' }}>Insufficient Balance </p>
      <>
        Select campaign duration
        <Box sx={{ display: 'flex', justifyContent: 'left', flexWrap: 'wrap', gap: '12px ' }}>
          {fields[1].map(({ name, label, display, type }) => {
            return type !== 'checkbox' ? (
              <PickDate name={name} label={label} display={display} sx={{ width: '200px', display: display }} />
            ) : (
              <StartSwitch childToParent={(data) => { setNow(data) }} />
            )
          })}
          <p className='text-danger' style={{ display: date.start > date.end ? 'block' : 'none' }}>Start date should be before the end </p>
        </Box>
      </>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: { xs: 'column', lg: 'row' }, width: '100%', justifyContent: 'space-between', mb: '47px', rowGap: '24px' }}>
        {fields[2].map(({ name, label, type, labelwithin, shortlabel, options, valueKey, idKey, limit, placeholder }) => {
          return type !== 'file' ? (
            type !== 'selectWithBtn' ? (
              <Box width={{ xs: '100%', lg: '48%' }}>
                <Input
                  name={name}
                  label={label}
                  placeholder={placeholder}
                  options={options}
                  variant="filled"
                  type={type}
                  key={name}
                  style={{ width: '100%' }}
                />
              </Box>
            ) : (
              <Box width={{ xs: '100%', lg: '48%' }}>
                <MultipleSelectPlaceholder
                  name={name} label={label} labelWithin={labelwithin} shortlabel={shortlabel} opt={options} valueKey={valueKey} idKey={idKey} limit={limit} placeholder={placeholder}
                />
              </Box>
            )
          ) : (
            <Box sx={{ width: '48%', height: 'auto', padding: '0' }}>
              <FileUpload name={'media'} label={'Upload a video or photo'} style={{ width: '100%' }} padding={'4'} /></Box>
          )
        })}
      </Box>
    </Box >
  )
}
